var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 1)?_c('SchoolTeacherLeaveControl'):(_vm.type === 2)?_c('SchoolStaffLeaveControl'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }